import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ConceptInterface } from '../+models';

export const CONCEPT_SERVICE_TOKEN = new InjectionToken('ConceptServiceInterface');

export interface ConceptServiceInterface {
  getAllForUser(userId: number): Observable<ConceptInterface[]>;
}
